import { render, staticRenderFns } from "./BasicInput.vue?vue&type=template&id=b95c85ae&scoped=true&"
import script from "./BasicInput.vue?vue&type=script&lang=js&"
export * from "./BasicInput.vue?vue&type=script&lang=js&"
import style0 from "./BasicInput.vue?vue&type=style&index=0&id=b95c85ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95c85ae",
  null
  
)

export default component.exports